<template>
  <b-modal id="modal-pause" data-backdrop="static" data-keyboard="false" centered
    :title="this.$t('Informe a Justificativa')">

    <div class="container">
      <select class="custom-select custom-select-lg mb-3" id="selectJustificativa" v-model="valorSelecionado"
        @change="validaAguardandoPeca">
        <option selected>{{ this.$t('Justificativa') }}</option>
        <option value="Ir ao banheiro">{{ this.$t('ir ao banheiro') }}</option>
        <option value="Atendimento">{{ this.$t('Atendimento') }}</option>
        <option value="Refeicao">{{ this.$t('Refeição') }}</option>
        <option value="Aguardando Peças">{{ this.$t('Aguardando Peças') }}</option>
        <option value="Auxílio externo">{{ this.$t('Auxílio externo') }}</option>
        <option value="Deslocamento">{{ this.$t('Deslocamento') }}</option>
      </select>

      <div v-show="showDivPecas">
        <span>{{ this.$t('Selecione qual peça está aguardando') }}:</span>
        <v-select id="label-items" class="mb-3" :options="materiais()" v-model="selectItem"
          :placeholder="this.$t('Peça')"></v-select>

      </div>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="w-100">
        <div class="row center" style="justify-content: center;">
          <b-button class="mr-2" variant="info" size="lg" @click="informarPause()">
            {{ $t('Confirmar Pausa') }}
          </b-button>
          <b-button class="mr-2" variant="danger" size="lg" @click="cancel()">
            {{ $t('Cancelar') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>

export default {
  name: "ModalExterna",
  props: {
    item: {},
    os: {}
  },
  data() {
    return {
      valorSelecionado: this.$t('Justificativa'),
      selectItem: '',
      showDivPecas: false
    };
  },

  computed: {

  },
  methods: {
    informarPause() {
      if (this.valorSelecionado == this.$t('Justificativa')) {
        this.$swal.fire({
          title: 'Oops!',
          text: 'Informe uma justificativa',
          icon: 'warning'
        })

        return false
      }

      if (this.valorSelecionado == this.$t('Aguardando Peças') && !this.selectItem) {
        this.$swal.fire({
          title: 'Oops!',
          text: 'Informe uma peça',
          icon: 'warning'
        })

        return false
      }

      if(this.valorSelecionado !== this.$t('Aguardando Peças')){
        this.selectItem = ''
      }

      const execucao = {
        nr_seq_os: this.$route.params.id,
        id: this.item.execucao_final.id,
        nr_seq_os_item: this.item.nr_sequencial,
        nr_seq_clifor: this.item.execucao_inicio.nr_seq_clifor_inicio,
        justificativa: this.valorSelecionado,
        peca: this.selectItem
      }


      this.$store.dispatch('osItemExecucao/initPause', { data: execucao }).then(response => {
        this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
        this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi')
        this.$bvModal.hide('modal-pause')
        // this.$store.dispatch('osItem/fetchItemFromApiPreventiva', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
        this.pause = false
        this.$emit('resetPause')
      }).catch(() => {
        this.$swal.fire({
          title: 'Oops!',
          text: 'Falha ao pausar execução. Tente novamente.',
          icon: 'error'
        })

        return false
      })
    },

    validaAguardandoPeca() {
      if (this.valorSelecionado == this.$t('Aguardando Peças')) {
        this.showDivPecas = true
      } else {
        this.showDivPecas = false
      }
    },

    materiais() {
      const materiais = this.$store.getters['frotaItem/materiais']

      if (materiais) {
        return materiais.map(material => {

          return {
            ...material,
            label: material.ds_codigoitem != null ? material.ds_codigoitem + ' - ' + material.ds_item : material.ds_item
          }
        })
      } else {
        return []
      }
    },
    
    getInfOs() {
      this.$store.dispatch('os/getDetails', { nrSequencial: this.$route.params.id }).then(response => {
        this.nr_conjunto = response.data.nr_conjunto
        this.idConjunto = response.data.nr_conjunto

        var empresa = JSON.parse(localStorage.empresa)
        let filial = this.$store.getters['filial/filial']
        let filialCerta = ''

        if (filial.infColab.newFilial) {
          filialCerta = filial.infColab.newFilial
        } else {
          filialCerta = filial.nr_sequencial
        }

        const data = {
          nrOs: this.$route.params.id,
          empresa: empresa,
          filial: filialCerta,
          stOrigem: 'I'
        }

        if (response.data.st_origem == 'E') {
          data.stOrigem = 'E'
        }

        this.$store.dispatch('frotaItem/fetchFromMateriais', { data: data })
      }).catch(error => {
        console.log(error)
      })
    },
  },
  created() {
    this.getInfOs()
  }
}
</script>
<style>
.divAcessoRapido {
  border-bottom: 1px solid #c5c5c5;
  padding-top: 10px;
  padding-left: 30px;
  text-align: left;
}

.nomeAcessoRapido {
  font-size: 20px;
  margin-bottom: 0px;
}
</style>